import React from 'react'
import PageHeader from '../shared/pageHeader/PageHeader'
import Footer from '../shared/Footer'
import Header from '../shared/header/Header'
import NavigationMenu from '../shared/navigationMenu/NavigationMenu'
import MemberHeader from './MemberHeader'
import MemberTable from './MemberTable'

const MemberList = () => {
    return (
        <>

            <Header />
            <NavigationMenu />
            <main className="nxl-container">
                <div className="nxl-content">
                    <PageHeader >
                        <MemberHeader />
                    </PageHeader>
                    <div className='main-content'>
                        <div className='row'>
                            <MemberTable />
                        </div>
                    </div>
                    <Footer />
                </div>
            </main>
        </>
    )
}

export default MemberList